import { css } from '@emotion/react';

import { screens } from '../shared/styles';

export const panelContainer = css`
  position: absolute;
  right: 0;
  bottom: calc(100% + var(--spacing-2));
  z-index: 1;

  @media (max-width: calc(${screens.lg} - 1px)) {
    position: fixed;
    inset: 0;
    background: var(--surface-page);
    overscroll-behavior: contain;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
`;

export const panelCard = (width: number | string) => css`
  background: var(--surface-page);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  padding: var(--spacing-4);
  box-shadow: 0 0 var(--shadow-blur-lg, 24px) var(--shadow-spread-xs, -4px)
    rgba(17, 17, 17, 0.1);

  /* Width passed from props (desktop/tablet) */
  width: ${typeof width === 'number' ? `${width}px` : width};

  /* Scale animation on open */
  transform-origin: bottom right;
  animation: widgetScaleIn 0.25s cubic-bezier(0.34, 1.2, 0.64, 1);

  @keyframes widgetScaleIn {
    from {
      transform: scale(0.7);
    }
    to {
      transform: scale(1);
    }
  }

  @media (max-width: calc(${screens.lg} - 1px)) {
    width: 100%;
    height: var(--widget-panel-height, 100%);
    max-height: none;
    margin-top: var(--widget-panel-top, 0px);
    border-radius: 0;
    padding: var(--spacing-4);
    padding-bottom: calc(var(--spacing-4) + env(safe-area-inset-bottom));
    overflow: auto;
    animation: none;
  }
`;

export const widgetTrigger = css`
  margin: var(--spacing-1);
  box-shadow: var(--shadow-2xl);
`;
